/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 792af791d448572f10582f317b7ad8b1 */

import { ConcreteRequest } from "relay-runtime";
export type OnlineCheckoutCheck = "DOCUMENT_UPLOAD_NEEDED" | "INVALID_STATE" | "LINK_UBER_NEEDED" | "LINK_UBER_SKIPPED" | "PAYMENT_NEEDED" | "POLICY_LIVE" | "POLICY_SUMMARY" | "TERMS_OF_BUSINESS_NEEDED" | "VERIFY_EMAIL_NEEDED" | "ZEGO_CHECKS_NEEDED" | "%future added value";
export type OnlineCheckoutStatus = "BOUND" | "CHECKS_COMPLETED" | "PAID_FOR" | "PERSONAL_DETAILS_FILLED" | "QUOTE_REFINED" | "QUOTE_SELECTED" | "STARTED" | "%future added value";
export type useOnlineCheckoutProgressQueryVariables = {
    category: string;
};
export type useOnlineCheckoutProgressQueryResponse = {
    readonly viewer: {
        readonly onlineCheckoutProgress: {
            readonly categoryCode: string;
            readonly status: OnlineCheckoutStatus;
            readonly currentCheck: OnlineCheckoutCheck | null;
            readonly selectedProduct: {
                readonly code: string;
            } | null;
            readonly onlineCheckoutEnabled: boolean;
        } | null;
    };
};
export type useOnlineCheckoutProgressQuery = {
    readonly response: useOnlineCheckoutProgressQueryResponse;
    readonly variables: useOnlineCheckoutProgressQueryVariables;
};



/*
query useOnlineCheckoutProgressQuery(
  $category: String!
) {
  viewer {
    onlineCheckoutProgress(category: $category) {
      categoryCode
      status
      currentCheck
      selectedProduct {
        __typename
        code
        id
      }
      onlineCheckoutEnabled
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "category",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "category",
    "variableName": "category"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "categoryCode",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "currentCheck",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "onlineCheckoutEnabled",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "useOnlineCheckoutProgressQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "onlineCheckoutProgress",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "OnlineCheckoutProgress",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "selectedProduct",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ]
              },
              (v6/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "useOnlineCheckoutProgressQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "onlineCheckoutProgress",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "OnlineCheckoutProgress",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "selectedProduct",
                "storageKey": null,
                "args": null,
                "concreteType": null,
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "__typename",
                    "args": null,
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  (v7/*: any*/)
                ]
              },
              (v6/*: any*/),
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "useOnlineCheckoutProgressQuery",
    "id": null,
    "text": "query useOnlineCheckoutProgressQuery(\n  $category: String!\n) {\n  viewer {\n    onlineCheckoutProgress(category: $category) {\n      categoryCode\n      status\n      currentCheck\n      selectedProduct {\n        __typename\n        code\n        id\n      }\n      onlineCheckoutEnabled\n      id\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'd93856803c00effcf9f77047359d37a9';
export default node;
